import { NewsItem } from '../types';

export const newsItems: NewsItem[] = [
  {
    id: '3b-workday-partnership-2026',
    title: '3B Consulting and Workday Announce Strategic Sales Partnership',
    date: '2026-03-01',
    summary:
      '3B Consulting and Workday have entered a strategic sales partnership to bring leading cloud ERP and HCM solutions to enterprises across Southeast Asia.',
    content:
      'In March 2026, 3B Consulting formalized a strategic sales partnership with Workday. Through this collaboration, 3B Consulting will help organizations in Southeast Asia plan, implement, and scale Workday-based solutions, combining deep regional expertise with Workday’s world-class cloud platform.',
  },
];

